import './styles/globals.css';

import * as Sentry from '@sentry/react';
import { RouterProvider } from '@tanstack/react-router';
import { Analytics } from '@vercel/analytics/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorFallback } from '@/components/observability/ErrorFallback';
import { QueryProvider } from '@/components/providers/QueryProvider';
import { ThemeProvider } from '@/components/providers/ThemeProvider';
import { initSentry } from '@/lib/observability/sentry';

import { router } from './router';

initSentry({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD,
});

function Root() {
  return (
    <StrictMode>
      <ThemeProvider>
        <Sentry.ErrorBoundary
          fallback={({ resetError }) => (
            <ErrorFallback resetError={resetError} />
          )}
        >
          <QueryProvider>
            <RouterProvider router={router} />
            <Analytics />
          </QueryProvider>
        </Sentry.ErrorBoundary>
      </ThemeProvider>
    </StrictMode>
  );
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(<Root />);
